import * as React from 'react';
import type { SVGProps } from 'react';
const SvgXCircle = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} {...props}>
        <circle cx={14} cy={14} r={8.464} fill="none" className="x-circle-bg" />
        <path
            fill="currentColor"
            d="M14 4C8.486 4 4 8.486 4 14s4.486 10 10 10 10-4.486 10-10S19.514 4 14 4m4.207 12.793-1.414 1.414L14 15.414l-2.793 2.793-1.414-1.414L12.586 14l-2.793-2.793 1.414-1.414L14 12.586l2.793-2.793 1.414 1.414L15.414 14z"
        />
    </svg>
);
export default SvgXCircle;
